<h2 mat-dialog-title>Map Well "{{ data.sourceId }}" — Select Target Well</h2>
<div mat-dialog-content>
  <div class="picker-source-ref" *ngIf="data.sourceWellName || data.sourceApi">
    Source: <strong>{{ data.sourceWellName || '(unnamed)' }}</strong>
    <span *ngIf="data.sourceApi"> — API {{ data.sourceApi }}</span>
  </div>

  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>Search wells</mat-label>
    <input matInput [(ngModel)]="search" (ngModelChange)="onSearchChange()" placeholder="Well name or API" />
  </mat-form-field>

  <div *ngIf="loading" class="picker-status">Searching...</div>
  <mat-selection-list *ngIf="!loading" [multiple]="false">
    <mat-list-option *ngFor="let opt of options" (click)="select(opt)">
      {{ opt.label }}
    </mat-list-option>
  </mat-selection-list>
  <div *ngIf="!loading && options.length === 0" class="picker-status">No matching wells found.</div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
</div>
